import React from 'react';

const DeviceTypeContent = {
  'ilt': {
    title: 'You have unsaved changes',
    primaryText: null,
    secondaryText: null
  }
};

export type UnsavedChangesModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  deviceType?: keyof typeof DeviceTypeContent;
};

function WarningIcon() {
  return (
    <svg
      className="unsaved-modal-icon"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
  );
}
function UnsavedChangesModal({
  isOpen,
  onClose,
  onContinue,
  deviceType = 'ilt'
}: UnsavedChangesModalProps) {
  if (!isOpen) {
    return null;
  }

  const { title, primaryText, secondaryText } = DeviceTypeContent[deviceType];

  const getSubtitles = () => {
    if (primaryText) {
      return (
        <p className="unsaved-modal-warning-text">
          {primaryText}
          <br />
          {secondaryText}
        </p>
      );
    }
    return null;
  };

  return (
    <div className="unsaved-modal-overlay">
      <div className="unsaved-modal-panel">
        <div className="unsaved-modal-content">
          <WarningIcon />
          <h2 className="unsaved-modal-title">{title}</h2>
          <div className="unsaved-modal-subtitle">{getSubtitles()}</div>
          <div className="unsaved-modal-button-container">
            <div className="unsaved-modal-button-left">
              <button className="unsaved-modal-continue" onClick={onContinue}>
                Continue without Saving
              </button>
            </div>
            <div className="unsaved-modal-button-right">
              <button className="unsaved-modal-cancel" onClick={onClose}>
                Cancel and Stay on Page
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnsavedChangesModal;
